<template>
  <div class="page-root">
    <h1>
      <span class="font-weight-bold" style="font-family: maplestory"> 알립니다 </span>
    </h1>

    <div class="app-page__content mt-4 pa-4">
      <div>
        <v-tabs v-model="index" background-color="transparent" color="primary lighten-1">
          <v-tab> FAQ </v-tab>
          <v-tab>
            <v-badge color="error" content="3"> 업데이트노트 </v-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items class="mt-6 pl-2" v-model="index" style="background-color: transparent; min-height: 78px">
          <v-tab-item>
            <div>
              <h5>Q: 버츄펫은 무엇인가요?</h5>
              <p class="ml-2">
                버츄펫은 스트리머를 위한 디지털 반려동물입니다. 다양한 애니메이션과 애셋들을 이용해서 풍부한 리액션을
                만들어보세요.
              </p>
            </div>

            <!-- <div>
              <h5>Q: 방송에 출연한 버츄펫을 유튜브등 다른 플랫폼에 올려도 되나요?</h5>
              <p class="ml-2">물론입니다. 버츄펫의 애니메이션이나, 리소스를 자유롭게 사용하셔도 됩니다</p>
            </div> -->

            <div>
              <h5>Q: 버츄펫 프로필이 업데이트 되지 않아요</h5>
              <p class="ml-2">OBS 브라우저 안에 Refresh 버튼을 눌러서 재시작 해보세요 <a>자세히 보기</a></p>
            </div>
          </v-tab-item>
          <v-tab-item>
            <ul style="list-style: none">
              <li class="mt-4" v-for="({ href, title, isNew }, i) in list" :key="i">
                <div class="d-flex pos-rel">
                  <div v-if="isNew" class="pos-abs" style="left: -8px; top: -12px">
                    <v-badge color="error" dot></v-badge>
                  </div>

                  <a :href="href" target="_blank" style="text-decoration: none; color: inherit">
                    <h5>{{ title }}</h5>
                  </a>
                  <v-icon class="ml-1" small>mdi-open-in-new</v-icon>
                </div>
              </li>
            </ul>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
const list = [
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-03-08-d5b6bc1a36ed49a5b04932a51cc30465?pvs=74",
    title: "2024.03.08 | 레벨 저장 기능 추가",
    isNew: true,
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-03-08-c9715ccbf6d745e2a165e48a40d2d36c?pvs=74",
    title: "2024.03.08 | 스트리머 상태 알림 기능 추가",
    isNew: true,
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-03-08-d4ab811301f8438f83796ea5c434767d",
    title: "2024.03.08 | 버츄펫 프로필 기능 안내",
    isNew: true,
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-02-13-102da34f08f44d1a8236d9618db24e58",
    title: "2024.02.13 | 라이브 리모컨 기능안내",
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-02-05-4ad732d4b86f4accbc1513e52c2d31ec?pvs=74",
    title: "2024.02.05 | 세팅페이지 > 캐릭터 선택 안내",
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-01-28-6e765424cab9423cbe452a246eece22d?pvs=74",
    title: "2024.01.28 | 채팅 키워드 반응 안내",
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-01-27-63abcb13b42d4c28a4203b06c3d6ce77",
    title: "2024.01.27 | 네이버 치지직 연동안내",
  },
  {
    href: "https://neighborly-sardine-b42.notion.site/2024-01-23-f0cb778682864f9b8aa71811a7f55a96?pvs=74",
    title: "2024.01.23 | 이펙트 기능 추가 안내",
  },
];
export default {
  data() {
    return {
      index: 0,
      list,
    };
  },
  mounted() {},
};
</script>

<style scoped></style>
